/**
 * Jarallax Library
 * Loaded conditionally via ACF theme options
 */

import { jarallax } from 'jarallax';

// Make available globally
window.jarallax = jarallax;

// Add jQuery plugin support (for legacy compatibility)
if (typeof jQuery !== 'undefined') {
  jQuery.fn.jarallax = function(options) {
    return this.each(function() {
      jarallax(this, options);
    });
  };
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  if (typeof jarallax !== 'undefined') {
    // Auto-initialize elements with .jarallax class
    jarallax(document.querySelectorAll('.jarallax'), {
      speed: 0.5,
      imgElement: '.jarallax-img'
    });

    console.log('Jarallax loaded and initialized');
  }
});